<template>
  <div
    class="success"
    :style="'min-height:' + (fullHeight-80) + 'px;'"
  >
    <!-- 头图 -->
    <div class="headImgs">
      <img src="../../assets/imgs/apply/bg.png">
      <div class="title">
        <img src="../../assets/imgs/apply/loan_success.png">
        <div class="loan_list">
          <div class="top ">
            已为您智能匹配产品并测算授信额度
          </div>
          <div
            class="list"
            v-for="(item,idx) in bankList"
            :key="idx"
            :class="idx===index ? 'hover':''"
            @click="son(idx)"
          >
            <div class="bankName"><img
                src="../../assets/imgs/apply/success_icon.png"
              >
              <div class="name">
                <div class="top">{{item.loanName}}</div>
                <div class="btn">{{item.bankName}}</div>
              </div>
            </div>
            <div class="right">
              <div class="lilv">
                <div class="top1">{{item.interestRate}}
                </div>
                <div class="btn">年利率（%）</div>
              </div>
              <div class="lilv">
                <div class="top">{{item.lines}}
                </div>
                <div class="btn">额度（万元）</div>
              </div>
              <div class="lilv1">
                <div class="top">{{item.loan}}
                </div>
                <div class="btn">贷款（月）</div>
              </div>
            </div>
          </div>
          <div
            class="withdrawals"
            @click="withdrawals"
          >我要提款</div>
          <div class="text">您的需求已推送至平台合作金融机构，将会有业务人员通过您的账号预留电话联系您。</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      fullHeight: document.documentElement.clientHeight,
      fullWidth: document.documentElement.clientWidth,
      bankList: [{
        bankName: '中国工商银行苏州分行',
        loanName: '中国工商银行XX贷',
        interestRate: '4.35',
        lines: '80',
        loan: "12"
      }, {
        bankName: '中国银行苏州分行',
        loanName: '中国银行XX贷',
        interestRate: '4.5',
        lines: '100',
        loan: "12"
      },
      {
        bankName: '苏州银行',
        loanName: '苏州银行XX贷',
        interestRate: '4.45',
        lines: '90',
        loan: "12"
      },
      {
        bankName: '苏州银行',
        loanName: '苏州银行XX贷',
        interestRate: '4.45',
        lines: '90',
        loan: "12"
      },
      {
        bankName: '苏州银行',
        loanName: '苏州银行XX贷',
        interestRate: '4.45',
        lines: '90',
        loan: "12"
      },
      ],
      index: 0
    };
  },
  watch: {
    fullHeight (val) {//监控浏览器高度变化
      if (!this.timer) {
        this.fullHeight = val
        this.timer = true
        let that = this
        setTimeout(function () {
          that.timer = false
        }, 400)
      }
    }
  },
  mounted () {
    this.get_bodyHeight()
  },
  methods: {
    get_bodyHeight () {//动态获取浏览器高度
      const that = this
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight
          that.fullHeight = window.fullHeight
        })()
      }
    },
    withdrawals () {
      this.$router.push({
        path: "apply_success",
      })
    },
    son (idx) {
      this.index = idx;
    }

  }

}
</script>

<style lang="less" scoped>
.success {
  .headImgs {
    img {
      width: 100%;
    }
  }
  .title {
    margin-top: 34px;
    text-align: center;
    img {
      width: 722px;
      height: 30px;
    }
    .loan_list {
      margin-top: 24px;
      padding-bottom: 71px;
      background-color: #fff;
      .top {
        font-size: 22px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #2a2a2a;
        line-height: 51px;
      }
      .list {
        width: 833px;
        margin: 43px auto 0;
        padding-right: 15px;
        padding-left: 35px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        border: 1px solid #d3d5dc;
        border-radius: 6px;
        cursor: pointer;

        .bankName {
          display: flex;
          align-items: center;
          img {
            width: 50px;
            height: 50px;
          }
          .name {
            .top {
              font-size: 22px;
              font-family: Alibaba PuHuiTi;
              font-weight: 500;
              color: #2a2a2a;
              text-align: left;
            }
            .btn {
              font-size: 16px;
              font-family: Alibaba PuHuiTi;
              font-weight: 400;
              color: #595858;
              text-align: left;
            }
            margin-left: 5px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
          }
        }
        .right {
          display: flex;
          padding: 23px 0;
          .lilv {
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: space-between;
            border-right: 1px solid #d5d5d5;
            width: 150px;
          }
          .lilv1 {
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: space-between;
            width: 150px;
          }
          .top1 {
            width: 53px;
            height: 19px;
            font-size: 26px;
            font-family: Alibaba PuHuiTi;
            font-weight: bold;
            color: #b90c1c;
            line-height: 22px;
          }
          .top {
            width: 29px;
            height: 19px;
            font-size: 26px;
            font-family: Alibaba PuHuiTi;
            font-weight: bold;
            color: #2a2a2a;
            line-height: 22px;
          }
          .btn {
            margin-top: 10px;
            font-size: 16px;
            font-family: Alibaba PuHuiTi;
            font-weight: 400;
            color: #595858;
            line-height: 22px;
          }
        }
      }
      .withdrawals {
        text-align: center;
        line-height: 56px;
        width: 210px;
        height: 56px;
        background: #2981ee;
        box-shadow: 0px 8px 4px 0px rgba(0, 0, 0, 0.12);
        border-radius: 11px;
        font-size: 22px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #ffffff;
        margin: 38px auto;
        cursor: pointer;
      }
      .text {
        white-space: nowrap;
        height: 22px;
        font-size: 22px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2a2a2a;
        line-height: 51px;
      }
    }
    .hover {
      border: 1px solid #2981ee !important;
      box-shadow: 0px 0px 6px 0px rgba(0, 70, 157, 0.6) !important;
      background: #f9fcff;
    }
  }
}
</style>